import ArticleLayout from '@/components/feature/ArticleLayout';
import { sugargooShippingCost } from '@/utils/articleContent';

export default function SugargooShippingCostPage() {
  return <ArticleLayout article={sugargooShippingCost} />;
}